import React, { useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import Image from "react-bootstrap/Image";
import profileUser from "../../assets/images/user-bg.png";
import NavDropdown from "react-bootstrap/NavDropdown";
import Logout from "@mui/icons-material/Logout";
import ListItemIcon from "@mui/material/ListItemIcon";
import { useNavigate } from "react-router-dom";
import AccountCircleSharpIcon from '@mui/icons-material/AccountCircleSharp';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import SettingsIcon from '@mui/icons-material/Settings';
import { Menu } from "@mui/material";
import MenuItem from '@mui/material/MenuItem';
import moment from "moment/moment";
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Modal from 'react-bootstrap/Modal';


const Header = () => {
  const navigate = useNavigate()
  const [modalOpen, setModalOpen] = React.useState(false);

  const toggleModal = () => {
    setModalOpen(true);
  }
  const handleClose = () => {
    setModalOpen(false);
  }
  
  const [drop, setDrop] = React.useState(null);

  const handleProfile = (event) => {
    setDrop(event.currentTarget);

  }

  const handleCloseProfile = () => {
    setDrop(null);
  }


  const token = localStorage.getItem("_token");

  const userData = JSON.parse(localStorage.getItem("userData"));
  const employeeName = userData?.[0]?.employeeName;

  useEffect(() => {
    const MINUTE_MS = 30000; //60000;
    const interval = setInterval(async () => {
      const currentTime = moment(Date().toLocaleString());
      const prevTime = moment(localStorage.getItem("LoggedInTime"));
      console.log("Login Time -", prevTime)
      console.log("Current Time -", currentTime)

      if (localStorage.getItem("LoggedInTime") !== undefined) {
        const duration = currentTime.diff(prevTime, "minutes");
        console.log("Duration -", duration)
        if (duration >= 45) {
          onLogoutClicked();
        }
      }
    }, MINUTE_MS);
    return () => clearInterval(interval);
  }, []);
  const onLogoutClicked = () => {
    localStorage.removeItem("_token");
    localStorage.removeItem('LoggedInTime')
    localStorage.removeItem('userData')
    navigate('/')
  }


  return (
    <>
      {token ?
        <header>
          <div className="header-main">
            <div className="header-group d-flex justify-content-lg-between justify-content-end align-items-center w-100">
              <div className="header-right">

                {/* <NavDropdown
                    title={
                      <div className="profile-img-box">
                        <Image
                          src={profileUser}
                          alt={"User Profile Image"}
                          fluid
                          roundedCircle
                          className="me-2"
                        />
                        <span className="">{employeeName}</span>
                      </div>
                    }
                    id="nav-dropdown"
                    className="profile-dropdown d-lg-block "
                  >

                </NavDropdown> */}
                <Stack direction="row">
                  <Avatar alt={"User Profile Image"} src={profileUser} roundedCircle
                    fluid className="me-2" />
                  <span style={{
                    margin: "8px", marginLeft: "5px"
                  }}>{employeeName}</span>
                </Stack>


                <SettingsOutlinedIcon fontSize="medium" style={{ position: "absolute", right: "43px", bottom: "33px", cursor: "pointer" }} onClick={(e) => handleProfile(e)} />

                <Menu
                  keepMounted
                  anchorEl={drop}
                  open={Boolean(drop)}
                  onClose={handleCloseProfile}
                >
                  <MenuItem onClick={() => toggleModal()}>
                    <ListItemIcon >
                      <AccountCircleSharpIcon fontSize="medium" />
                    </ListItemIcon>
                    Profile
                  </MenuItem>

                  <MenuItem onClick={() => onLogoutClicked()}>
                      <ListItemIcon>
                      <Logout fontSize="medium" />
                      </ListItemIcon>
                    Log Out</MenuItem>
                </Menu>


                {/* Modal For Edit Profile */}

                <Modal show={modalOpen} onHide={handleClose} size="sm" centered>
                  <Modal.Body >
                    <div className="d-flex align-items-center justify-content-center" style={{ marginTop: "65px" }}>
                      <Image
                        src={profileUser}
                        alt={"User Profile Image"}
                      />
                      <br />
                    </div>
                    <small className="d-flex align-items-center justify-content-center" style={{ padding: "13px", margin: "20px" }}>
                      Admin Name
                      {<BorderColorIcon style={{ fontSize: "small" }} />}
                    </small>
                  </Modal.Body>
                </Modal>
               
              </div>
            </div>
          </div>


        </header >
        : null}
    </>
  );
}

export default Header;
